import { apiGet, apiPost } from './client';
import type {
  PromptSummary, PromptDetail, PromptVariableCatalogEntry, SignalCareRole,
  CreatePromptRequest, CreateVersionRequest, RenderResponse, PromptVersionDetail,
} from './types';

export const listPrompts = (role?: SignalCareRole, includeArchived = false) => {
  const params = new URLSearchParams();
  if (role) params.set('role', role);
  if (includeArchived) params.set('includeArchived', 'true');
  const qs = params.toString();
  return apiGet<PromptSummary[]>(`/api/prompts${qs ? '?' + qs : ''}`);
};

export const getPrompt = (id: string) => apiGet<PromptDetail>(`/api/prompts/${id}`);
export const listRoles = () => apiGet<SignalCareRole[]>('/api/prompts/roles');
export const listVariables = () => apiGet<PromptVariableCatalogEntry[]>('/api/prompts/variables');

export const createPrompt = (body: CreatePromptRequest) =>
  apiPost<PromptDetail>('/api/prompts', body);

export const createVersion = (id: string, body: CreateVersionRequest) =>
  apiPost<PromptVersionDetail>(`/api/prompts/${id}/versions`, body);

export const approveVersion = (id: string, versionId: string) =>
  apiPost<PromptVersionDetail>(`/api/prompts/${id}/versions/${versionId}/approve`);

export const markProduction = (id: string, versionId: string) =>
  apiPost<PromptDetail>(`/api/prompts/${id}/versions/${versionId}/production`);

export const archivePrompt = (id: string) =>
  apiPost<PromptDetail>(`/api/prompts/${id}/archive`);

export const clonePrompt = (id: string, newName: string) =>
  apiPost<PromptDetail>(`/api/prompts/${id}/clone`, { newName });

export const renderPrompt = (
  id: string,
  versionId: string | null,
  variables: Record<string, string>,
) => apiPost<RenderResponse>(`/api/prompts/${id}/render`, { versionId, variables });
